<p-dialog [(visible)]="displayCommentDetailPopup" [modal]="true" [style]="{width: '50%'}" 
    [blockScroll]="true" (onHide)="hideComment()" [resizable]="false" appendTo="body" [focusOnShow]="false">
    <div class="header p-d-flex p-jc-between">
        <h5>{{wbParentComment?.categoryName}} <span *ngIf="wbParentComment?.subCategoryName">- {{wbParentComment?.subCategoryName}}</span></h5>
    </div>
    <p-card class="activity-card">
        <div class="p-d-flex">
            <div class="activity-icon p-shadow-3" [ngStyle]="{'background-color': wbParentComment?.categoryColor ?? '#ccc'}">
                <span class="pi pi-comment"></span>
              </div>
            <div class="activity-content">
                <ng-container *ngIf="noteArea">
                    <div style="word-break: break-all;" class="p-mb-0" *ngIf="wbParentComment" (mouseenter)="markAsReadParent(wbParentComment, $event)">
                        <div [ngClass]="{'unread-comment': wbParentComment?.isRead==false}">
                            <h6 class="p-mb-1" style="display: inline-block;">
                                  {{ wbParentComment?.userName }}
                            </h6>
                            <span class="p-ml-4" style="opacity: 0.8;">
                                {{wbParentComment?.createdDate | localDate}}
                            </span>
                            <span *ngIf="wbParentComment?.isUpdated" style="opacity: 0.8;" class="p-ml-2 p-mr-2">
                              (last modified: {{wbParentComment?.updatedDate | localDate}})
                         </span>

                            <div class="p-jc-end" *ngIf="!isViewMode && wbParentComment?.allowEdit">
                                <div class="p-mr-1">
                                    <span class="btnBars p-mr-0" style="float: right;"
                                        (click)="showHideUpdateNote(wbParentComment, 'editParentComment')"
                                        >
                                        <i class="pi pi-pencil"></i>
                                    </span>
                                    <span class="btnBars p-mr-2" style="float: right;" (click)="deleteComment(wbParentComment)"
                                        >
                                        <i class="pi pi-trash"></i>
                                    </span>
                                </div>
                            </div>
                            <!-- <div style="word-break: break-all; white-space: pre-line;">{{wbParentComment?.content}}</div> -->
                            <div [innerHtml]="wbParentComment?.viewContent"></div>
                            <ng-container *ngIf="wbParentComment?.attachment?.length > 0">
                              <div class="wb-attachment">
                                <div *ngFor="let document of wbParentComment?.attachment">
                                  <div class="p-mb-0 attachment-details">
                                    <a target="_blank" rel="noopener noreferrer" (click)="openFilePreview($event,document)"
                                    class="truncate pointer" [pTooltip]="document?.name" tooltipPosition="top">
                                    <i class="pi pi-paperclip p-mr-1"></i> 
                                    {{ document?.name | shorten: 30 }}
                                    </a>
                                </div>
                              </div>  
                              </div>
                            </ng-container>
              
                        </div>
                        <ng-container *ngIf="wbChildComments?.length > 0">
                            <div *ngFor="let childComment of wbChildComments" (mouseenter)="markAsReadChild(childComment, $event)" class="innerComment" [ngClass]="{'unread-comment': childComment?.isRead==false}">
                                <h6 class="p-mb-1" style="display: inline-block;">
                                    {{childComment?.userName}} Commented
                                </h6>
                                <span class="p-ml-4" style="opacity: 0.8;">
                                    {{childComment?.createdDate | localDate}}
                                </span>
                                <span *ngIf="childComment?.isUpdated" style="opacity: 0.8;" class="p-ml-2 p-mr-2">
                                  (last modified: {{childComment?.updatedDate | localDate}})
                             </span>
                                <ng-container *ngIf="childComment.allowEdit">
                                    <span class="btnBars p-mr-0" style="float: right;"
                                    (click)="showHideUpdateNoteComment(childComment, 'editChildComment')"
                                    >
                                    <i class="pi pi-pencil"></i>
                                </span>
                                <span class="btnBars p-mr-2" style="float: right;" (click)="deleteComment(childComment)">
                                    <i class="pi pi-trash"></i>
                                </span>
                                </ng-container> 
                                <!-- <div style="word-break: break-all; white-space: pre-line;">{{childComment?.content}}</div> -->
                                <div [innerHtml]="childComment?.viewContent"></div>
                                <ng-container *ngIf="childComment?.attachment?.length > 0">
                                  <div class="wb-attachment">
                                    <div *ngFor="let document of childComment?.attachment">
                                      <div class="p-mb-0 attachment-details">
                                        <a target="_blank" rel="noopener noreferrer" (click)="openFilePreview($event,document)"
                                        class="truncate pointer" [pTooltip]="document?.name" tooltipPosition="top">
                                        <i class="pi pi-paperclip p-mr-1"></i> 
                                        {{ document?.name | shorten: 30 }}
                                        </a>
                                    </div>
                                  </div>
                                </div>
                                </ng-container>
                            </div>
                        </ng-container>

                    </div>
                </ng-container>
                <ng-container *ngIf="isUpdateNote">
                    <div class="p-grid">
                      <div class="p-col-6">
                        {{ wbParentComment?.userName }}
                      </div>
                      <div class="p-col-6 p-text-right">
                        <span class="btnBars p-mr-0" style="float: right;" (click)="isUpdateNote = false; noteArea = true;">
                          <i class="pi pi-times"></i>
                        </span>
                      </div>
                    </div>
                    <div class="p-grid">
                      <div class="p-col-12" style="position: relative">
                        <label for="updateNoteComment">Comments</label>
                        <quill-editor 
                        id="noteComment" 
                        [(ngModel)]="noteComment"
                        placeholder="Enter your comment"
                        [modules]="quillConfig"
                      ></quill-editor>
            
                        <div *ngIf="countPlainTextLength(noteComment) > 1000 || noteComment?.length > 5000" class="p-error p-mt-1">
                          Comment length should be less than or equal to 1000.
                        </div>
                      </div>
                    </div>
                    <div class="p-grid">
                      <div class="p-col-12">
                        <label>
                          Attachments
                          <i class="pi pi-exclamation-circle" escape="false" [pTooltip]="multiLineTooltip" tooltipPosition="top"></i>
                        </label>
                      
                        <p-fileUpload #fileUpload customUpload="true" [disabled]="isUploading" mode="basic" chooseLabel="Choose"
                          [showUploadButton]="false" [showCancelButton]="false" multiple="multiple"
                          (onSelect)="uploadAttachments($event, fileUpload,'editParentComment')" name="demo[]">
                        </p-fileUpload>
                        <ng-container *ngIf="logMap['editParentComment']?.log?.logAttachments && (logMap['editParentComment']?.log?.logAttachments?.length > 0)">
                          <app-lion-attachment-chips [attachments]="logMap['editParentComment']?.log?.logAttachments"
                              (removeAttachment)="removeAttachment($event, 'editParentComment')"></app-lion-attachment-chips>
                      </ng-container>  
                      </div>
                    </div>
                    <button pButton label="Save" style="float: right;" [disabled]="noteUpdateLoading || countPlainTextLength(noteComment) > 1000 ||noteComment?.length > 5000 " (click)="updateNote()"></button>
                  </ng-container>
                  
                  <ng-container *ngIf="isUpdateNoteComment">
                    <div class="p-grid">
                      <div class="p-col-12 p-text-right">
                        <span class="btnBars p-mr-0" style="float: right;" (click)="isUpdateNoteComment = false; noteArea = true;">
                          <i class="pi pi-times"></i>
                        </span>
                      </div>
                    </div>
                    <div class="p-grid">
                      <div class="p-col-12" style="position: relative">
                        <label for="updateNoteComment">Comments</label>
                        <quill-editor 
                        id="noteComment" 
                        [(ngModel)]="noteComment"
                        placeholder="Enter your comment"
                        [modules]="quillConfig"
                      ></quill-editor>

                        <div *ngIf="countPlainTextLength(noteComment)> 1000 || noteComment?.length > 5000" class="p-error p-mt-1">
                          Comment length should be less than or equal to 1000.
                        </div>
                      </div>
                    </div>
                    <div class="p-grid">
                      <div class="p-col-12">
                        <label>
                          Attachments
                          <i class="pi pi-exclamation-circle" escape="false" [pTooltip]="multiLineTooltip" tooltipPosition="top"></i>
                        </label>
                      
                        <p-fileUpload #fileUpload customUpload="true" [disabled]="isUploading" mode="basic" chooseLabel="Choose"
                          [showUploadButton]="false" [showCancelButton]="false" multiple="multiple"
                          (onSelect)="uploadAttachments($event, fileUpload,'editChildComment')" name="demo[]">
                        </p-fileUpload>
                        <ng-container *ngIf="logMap['editChildComment']?.log?.logAttachments && (logMap['editChildComment']?.log?.logAttachments?.length > 0)">
                          <app-lion-attachment-chips [attachments]="logMap['editChildComment']?.log?.logAttachments"
                              (removeAttachment)="removeAttachment($event, 'editChildComment')"></app-lion-attachment-chips>
                      </ng-container>  
                      </div>
                    </div>
                    <button pButton label="Save" style="float: right;" [disabled]="countPlainTextLength(noteComment) > 1000 || noteComment?.length > 5000" (click)="updateNoteComment()"></button>
                  </ng-container>
            </div>
        </div>
    </p-card>

    <div *ngIf="!isViewMode">
        <div class="p-grid" *ngIf="!isUpdateNote || !isUpdateNoteComment">
          <div class="p-col-12" style="position: relative">
            <label for="newComment">Comments</label>
            <quill-editor 
            id="newComment" 
            [(ngModel)]="newComment"
            placeholder="Enter your comment"
            [modules]="quillConfig"
          ></quill-editor>

            <div *ngIf="countPlainTextLength(newComment)> 1000 || newComment?.length>5000 " class="p-error p-mt-1">
              Comment length should be less than or equal to 1000.
            </div>
          </div>
          <div class="p-col-12">
            <label>
              Attachments
              <i class="pi pi-exclamation-circle" escape="false" [pTooltip]="multiLineTooltip" tooltipPosition="top"></i>
            </label>
          
            <p-fileUpload #fileUpload customUpload="true" [disabled]="isUploading" mode="basic" chooseLabel="Choose"
              [showUploadButton]="false" [showCancelButton]="false" multiple="multiple"
              (onSelect)="uploadAttachments($event, fileUpload,'newChildAttachment')" name="demo[]">
            </p-fileUpload>
            <ng-container *ngIf="logMap['newChildAttachment']?.log?.logAttachments && (logMap['newChildAttachment']?.log?.logAttachments?.length > 0)">
              <app-lion-attachment-chips [attachments]="logMap['newChildAttachment']?.log?.logAttachments"
                  (removeAttachment)="removeAttachment($event, 'newChildAttachment')"></app-lion-attachment-chips>
          </ng-container>  
          </div>
        </div>

      </div>

    <ng-template pTemplate="footer">
        <ng-container>
            <button pButton (click)="hideComment();isView=true;newComment=''" label="Cancel"
                class="p-button-secondary"></button>
            <button pButton label="Save" style="float: right;" (click)="saveNoteComment()"
                *ngIf="newComment !== '' && countPlainTextLength(newComment) < 1001 && newComment?.length < 5001" ></button>
        </ng-container>
    </ng-template>
</p-dialog>
<app-shared-file-opener *ngIf="displayFilePreview" [modalDisplay]="displayFilePreview" [modalFile]="currentFile" [directLink]="true" (closeFilePreview)="closeFilePreview()"></app-shared-file-opener>
<ng-container *ngIf="displayUserDetails&&selectedUserId">
  <user-details-modal [display]="displayUserDetails" [selectedUserId]="selectedUserId" 
  (close)="closeTaggedUserDetails()"></user-details-modal>
  
</ng-container>
<p-confirmDialog key="deleteCommentDetails" [style]="{ width: '20vw' }" [baseZIndex]="1000000"></p-confirmDialog>
